import { FC, useMemo } from 'react';
import { TeamOutlined } from '@ant-design/icons';
import { AuthenticatedUsersCountChartProps } from '../../../../../../core/domain/overview/authenticated-users-count';
import { RegisteredUsersCountChartProps } from '../../../../../../core/domain/overview/registered-users-count';
import { UploadedDocumentsChartProps } from '../../../../../../core/domain/overview/uploaded-documents';
import { ChartCard } from '../../components/chart-card/chart-card';
import { AreaSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    authenticatedUsersData: AuthenticatedUsersCountChartProps;
    registeredUsersData: RegisteredUsersCountChartProps;
    uploadedDocumentsData: UploadedDocumentsChartProps;
    chartLoading: boolean;
}

const series = [
    { key: 'registered', name: 'کاربران ثبت نام شده', color: CHART_COLORS.blue },
    { key: 'authenticated', name: 'کاربران احراز هویت شده', color: CHART_COLORS.green },
    { key: 'documents', name: 'مدارک آپلود شده', color: CHART_COLORS.amber },
];

export const UsersChart: FC<Props> = ({
    authenticatedUsersData,
    registeredUsersData,
    uploadedDocumentsData,
    chartLoading,
}) => {
    const data = useMemo(
        () =>
            mergeByDate([
                { key: 'registered', data: registeredUsersData?.registeredUserCount },
                { key: 'authenticated', data: authenticatedUsersData?.authenticatedUsersData },
                { key: 'documents', data: uploadedDocumentsData?.chartDatas },
            ]),
        [authenticatedUsersData, registeredUsersData, uploadedDocumentsData],
    );

    return (
        <ChartCard
            title="کاربران"
            subtitle="ثبت‌نام، احراز هویت و مدارک بارگذاری شده"
            icon={<TeamOutlined />}
            accent="blue"
            loading={chartLoading}
            empty={!data.length}
            wide
            stats={[
                { label: 'ثبت‌نام', value: faNumber(sumOf(data, 'registered')), color: CHART_COLORS.blue },
                { label: 'احراز هویت', value: faNumber(sumOf(data, 'authenticated')), color: CHART_COLORS.green },
                { label: 'مدارک', value: faNumber(sumOf(data, 'documents')), color: CHART_COLORS.amber },
            ]}
        >
            <AreaSeriesChart data={data} series={series} height={340} />
        </ChartCard>
    );
};
